import action from '../constants/userInfo';

export const getUserInfo = () => ({
    type: action.GET_USER_INFO,
});

export const getUserInfoSuccess = (responseData) => ({
    type: action.GET_USER_INFO_SUCCESS,
    payload: responseData
});